import {updatePointsInHeader} from "./updatePointsInHeader";
import {checkForRewards} from "../rewards/checkForRewards";
export function checkCodeActionInputAndAddPoints(id, code, input) {
    $.ajax({
        type: "POST",
        url: "/module/community/ajax.php?action=code_action_check_and_add",
        datatype: "json",
        data: {
            "ajax_call_post_id": id,
            "ajax_call_customer_no": customerNo,
            "ajax_call_code": code,
            "ajax_call_company": company,
            "ajax_call_shop_code": shopCode,
            "ajax_call_language_code": languageCode
        },
        success: function (output) {
            $("body").append(output);
            $('#success_modal_' + id).modal("show");
            updatePointsInHeader();
            input.val("");
        }
    });
}
